import { CutoutModel, SelectedItemMap } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface CutoutState {
    selectedCutouts: SelectedItemMap;
}

const initialState: CutoutState = {
    selectedCutouts: new Map(),
};

const cutoutSlice = createSlice({
    name: 'cutout',
    initialState,
    reducers: {
        addSelectedCutout: (state, action: PayloadAction<CutoutModel>) => {
            const newSelectedCutouts = new Map(state.selectedCutouts);
            newSelectedCutouts.set(action.payload.productId, {
                quantity: 1,
                isSelected: true,
                isManuallyChanged: false,
            });

            return {
                ...state,
                selectedCutouts: newSelectedCutouts,
            };
        },
        removeSelectedCutout: (state, action: PayloadAction<CutoutModel>) => {
            const newSelectedCutouts = new Map(state.selectedCutouts);
            newSelectedCutouts.delete(action.payload.productId);

            return {
                ...state,
                selectedCutouts: newSelectedCutouts,
            };
        },
        resetSelectedCutouts: (state) => {
            state.selectedCutouts = initialState.selectedCutouts;
        },
        updateSelectedCutouts: (state, action: PayloadAction<SelectedItemMap>) => {
            state.selectedCutouts = action.payload;
        },
    },
});

export const { addSelectedCutout, removeSelectedCutout, resetSelectedCutouts, updateSelectedCutouts } =
    cutoutSlice.actions;

export const selectSelectedCutouts = ({ cutout }: RootState): SelectedItemMap => cutout.selectedCutouts;

export default cutoutSlice.reducer;
